import { render } from "./CopyQuotation.vue?vue&type=template&id=5bde342a&scoped=true"
import script from "./CopyQuotation.vue?vue&type=script&lang=js"
export * from "./CopyQuotation.vue?vue&type=script&lang=js"

import "./CopyQuotation.vue?vue&type=style&index=0&id=5bde342a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bde342a"]])

export default __exports__